export const employeeGoalsColorsOptions = [
    { key: 'blue', text: 'Redovna aktivnost',  value: 'blue', image: '/assets/colorImages/blue.png' },
    { key: 'red', text: 'Prioritetno', value: 'red', image: '/assets/colorImages/red.png' },
    { key: 'orange', text: 'U planu', value: 'orange', image: '/assets/colorImages/orange.png' },
];